const sendReceiptSms = async (phoneNumber, orderReference) => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

    const response = await fetch(`${backendUrl}/api/sms/send-order-sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, orderReference }),
    });

    const result = await response.json();

    if (result.success) {
      return { success: true };
    } else {
      console.error('Failed to send SMS:', result.error);
      return { success: false, error: result.error };
    }
  } catch (error) {
    console.error('Error sending SMS:', error);
    return { success: false, error: error.message };
  }
};

export { sendReceiptSms };
